var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33301 3.33337H6.66634V33.3334H36.6663V36.6667H3.33301V3.33337ZM11.6663 16.6667H28.333V21.6667H11.6663V16.6667ZM18.333 25H34.9997V30H18.333V25ZM9.99968 6.66671H36.6663V13.3334H33.333V10H13.333V13.3334H9.99968V6.66671Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportWhite);
export default __webpack_public_path__ + "static/media/report-white.8800fc47e9710a6a8557f56c5414c244.svg";
export { ForwardRef as ReactComponent };